// declare var configEnvironment: any;
import { ConfigService } from "./config.service"; 
// import { ConfigService } from './config.service';
// var configEnvironment;
// configEnvironment = function () {
//     return {
//         sw_Environment: 'DEV',
//         sw_RestBaseUrl: 'http://clientworksdvi.sddev.lpl.com/',
//         AppServiceID: '317'
//     };
// };

export class AppSettings {
    // config = ConfigService;
    // public static APPLICATION_VERSION = '1.0.0';
    // public static SW_ENVIRONMENT = environmentConfig.sw_Environment;
    // public static HO_CORE_BASE_URL = environmentConfig.ho_core_base_url;
    // public static Mule_Service_URL = environmentConfig.muleServices;
    public static AuthOWA_Url = ConfigService.getPropertyValue('authOWA_Url');
    // App Access Token URL
    // public static LPLAccessTokenInfo = AppSettings.HO_CORE_BASE_URL + '/esb/lpl/resource/getaccesstoken';
    // login url
    // public static authenticateUser = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/validate/credentials';
    // reset email url
    // public static resetSubmitEmail = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/password/reset/submit/username';
    // mfachoice url
    // public static mfachoice = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/submit/mfachoice';
    // validate choice
    // public static validateChoice = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/validate/otp';
    // push status
    // public static pushStatus = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/push/status';
    // Device Concent
    // public static deviceConcent = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/device/concent';
    // Change Password url
    // public static changePassword = AppSettings.Mule_Service_URL + '/infosec/owa/advisor/password/reset/submit/newpassword';
    // Post auth OWA
    public static authOWA = AppSettings.AuthOWA_Url + '/owa/auth.owa';
}
